import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";
import con_spa_haz_lev from "../img/sswpIcons/ConfinedSpace/con_spa_haz_lev.png";
import con_spa_com from "../img/sswpIcons/ConfinedSpace/con_spa_com_ind.png";
import con_spa_com_ind from "../img/sswpIcons/ConfinedSpace/con_spa_com.png";
import con_spa_det_mon from "../img/sswpIcons/ConfinedSpace/con_spa_det_mon.png";
import con_spa_per_to_wor from "../img/sswpIcons/ConfinedSpace/con_spa_per_to_wor.png";
import con_spa_acc_egr from "../img/sswpIcons/ConfinedSpace/con_spa_acc_egr.png";
import con_spa_deg_emp_cle from "../img/sswpIcons/ConfinedSpace/con_spa_deg_emp_cle.png";
import con_spa_ins_che_cct from "../img/sswpIcons/ConfinedSpace/con_spa_ins_che_cct.png";
import con_spa_iso from "../img/sswpIcons/ConfinedSpace/con_spa_iso.png";
import con_spa_res_pla from "../img/sswpIcons/ConfinedSpace/con_spa_res_pla.png";
import con_spa_ris_ass_and_saf_pla from "../img/sswpIcons/ConfinedSpace/con_spa_ris_ass_and_saf_pla.png";
import con_spa_res_equ from "../img/sswpIcons/ConfinedSpace/con_spa_res_equ.png";
import con_spa_tag_on_off from "../img/sswpIcons/ConfinedSpace/con_spa_tag_on_off.png";
import con_spa_tra_sup from "../img/sswpIcons/ConfinedSpace/con_spa_tra_sup.png";
import con_spa_sur from "../img/sswpIcons/ConfinedSpace/con_spa_sur.png";
import con_spa_tri from "../img/sswpIcons/ConfinedSpace/con_spa_tri.png";
import con_spa_2_way_rad from "../img/sswpIcons/ConfinedSpace/con_spa_two_way_rad.jpg";
import con_spa_sit_spe_met_sta from "../img/sswpIcons/ConfinedSpace/con_spa_sit_spe_met.png";

const json = {
    icon: con_spa_haz_lev,
    name: "Confined Space",
    text:
        "‘Confined space’ refers to any place – including a vessel, tank, container, pit, bund, chamber, cellar or similar space – which, by virtue of its enclosed nature, creates conditions that could cause an accident, harm or injury that would require emergency action.",
    icons: {
        con_spa_tra_sup: {
            name: "Training/ Supervision/ Suitability",
            icon: con_spa_tra_sup,
            text: (
                <ul>
                    <ListItem text="Manual handling training is a legal requirement for anyone required to carry out manual handling operations at work." />
                    <ListItem text="In confined spaces all persons working, supervising, planning, implementing the safe system of work, or participating in a rescue will require adequate instruction and/or training. The complexity of the task will determine the level of training required." />
                    <ListItem text="Adequate supervision, by a person who has the authority to issue instructions, is essential to ensure the activity is completed as planned. For higher risk activities, this will require the person to be present on site during the activity. Workers, under supervision, should be fully informed and have a complete understanding of the potential hazards and the safe working system to be used." />
                    <ListItem text="Workers need to have the physical capability to undertake the task, within the work environment. They need to be fit for the work concerned." />
                    <ListItem text="Before a tool or piece of plant is used it must be checked for it’s suitability for the task, e.g. capacity, capability, safe working load etc." />
                </ul>
            )
        },
        con_spa_ris_ass_and_saf_pla: {
            name: "Risk Assess & Safety Plan Method",
            icon: con_spa_ris_ass_and_saf_pla,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        con_spa_sur: {
            name: "Survey",
            icon: con_spa_sur,
            text: (
                <ul>
                    <ListItem text="You can only survey in areas with sufficient lighting and visibility." />
                    <ListItem text="You should never survey while exposed to live traffic. You should have appropriate barriers, cones, safety zones etc in place." />
                    <ListItem text="The lateral safety zone from live traffic should be 0.5m when ≤ 60 km/h, and 1.2m when > 60 km/h. This includes while using the staff or target." />
                    <ListItem text="Select and implement an appropriate traffic management plan to provide you with a safe working area before commencing." />
                    <ListItem text="You must wear high visibility PPE (minimum Class 2)." />
                </ul>
            )
        },
        con_spa_deg_emp_cle: {
            name: "De-Gas/ Empty/ Clean",
            icon: con_spa_deg_emp_cle,
            text: (
                <ul>
                    <ListItem text="Restricted openings relative to the size of the space will adversely affect the success of/ length of time required for this operation." />
                    <ListItem text="After completing this procedure, the atmosphere needs to be tested to check that it has been effective, and that it is safe to allow people to enter without breathing apparatus." />
                    <ListItem text="Cross ventilation should be maintained (particularly at the top and bottom of the space). Ongoing mechanical ventilation of fresh clean air into the space may also be required. Do not use oxygen as it will create a fire/ explosion hazard along with being potentially toxic itself." />
                </ul>
            )
        },
        con_spa_ins_che_cct: {
            name: "Inspection/ Check/ CCTV",
            icon: con_spa_ins_che_cct,
            text: (
                <ul>
                    <ListItem text="Use information you have available to you, such as drawings, knowledge about local conditions or other experienced operators. Also use knowledge of previous contents, residues or potential contamination of the space." />
                    <Li>
                        <Typography variant="title">
                            Establish the presence of hazards such as
                        </Typography>
                        <ListItem text="Flammable substances or oxygen rich" />
                        <ListItem text="Excessive heat" />
                        <ListItem text="Toxic gas, fumes or vapour" />
                        <ListItem text="Oxygen deficiency" />
                        <ListItem text="Ingress or presence of liquids/ sold materials which can flow" />
                        <ListItem text="Other hazards." />
                    </Li>
                    <ListItem text="The test must be representative taking into account the geometry and physical work space." />
                    <ListItem text="The risk assessment will determine whether testing will be required intermittently or at scheduled intervals." />
                    <ListItem text="Testing of oxygen content (normally 21%) should take place first, as this may affect other testing of gases. Testing of Lower Explosive Limit or other asphyxiating contaminants can be done using suitable apparatus. Such apparatus must be within it’s calibration requirements and dates. Such records must be available for operatives using the equipment." />
                    <ListItem text="The equipment needs to be maintained and stored in accordance with the manufacturer’s instructions." />
                    <ListItem text="The testing must be carried out by trained operatives. The testing should be carried out from outside the confined space. If entry is required for testing, a site specific method statement is required." />
                </ul>
            )
        },
        con_spa_det_mon: {
            name: "Detect/ Monitor",
            icon: con_spa_det_mon,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Any doubt on the quality of the atmosphere within a
                            confined space will require the atmosphere to be
                            tested prior to entry.
                        </Typography>
                        <ol>
                            <ListItem text="Due to information on previous contents, proximity of nearby processes or conditions." />
                        </ol>
                    </Li>
                    <ListItem text="If the space was de-gasses/ purged etc it will also require testing." />
                    <ListItem text="The test must be representative taking into account the geometry and physical work space." />
                    <ListItem text="The risk assessment will determine whether testing will be required intermittently or at scheduled intervals." />
                    <ListItem text="Testing of oxygen content (normally 21%) should take place first, as this may affect other testing of gases. Testing of Lower Explosive Limit or other asphyxiating contaminants can be done using suitable apparatus. Such apparatus must be within it’s calibration requirements and dates. Such records must be available for operatives using the equipment." />
                    <ListItem text="The equipment needs to be maintained and stored in accordance with the manufacturer’s instructions." />
                    <ListItem
                        text="The testing must be carried out by trained operatives. The testing should be carried out from outside the confined space. If entry is required for testing, a site specific method statement is required.
"
                    />
                </ul>
            )
        },
        con_spa_res_pla: {
            name: "Rescue Plan",
            icon: con_spa_res_pla,
            text: (
                <ul>
                    <ListItem text="Where appropriate before entering the confined space, the necessary equipment to enable rescue and resuscitation must be available. This will be determined by the risk assessment." />
                    <Li>
                        <Typography variant="title">
                            The Rescue Plan should identify which of the
                            following is appropriate. The plan must be known be
                            the person(s) entering the confined space, and
                            anybody involved in the rescue. It will involve one
                            of the following methods
                        </Typography>
                        <ol>
                            <ListItem text="Self-rescue can be used where the nature of the hazards and control measures allow for this" />
                            <ListItem text="Rescue by trained team members using non-entry methods" />
                            <ListItem text="Rescue by trained team members using safe entry methods" />
                            <ListItem text="Rescue using safe entry by the emergency services (subject to adequate time being available)" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title" >
                        The rescue plan arrangements must provide for
                        </Typography>
                        <ol>
                            <ListItem text="Training required and availability on site" />
                            <ListItem text="Rescue logistics" />
                            <ListItem text="Rescue equipment" />
                            <ListItem text="Resuscitation procedures and equipment" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        con_spa_iso: {
            name: "Isolate/ Lock Out",
            icon: con_spa_iso,
            text: (
                <ul>
                    <ListItem text="This is required when undertaking electrical works and electric power to the site remains live" />
                    <ListItem text="A permit to work system is required (personnel and timings)" />
                    <ListItem text="The required network needs to be isolated from the main system, with the isolation point locked out and tagged." />
                    <ListItem text="The isolation needs to be verified before any work can commence." />
                </ul>
            )
        },

        con_spa_2_way_rad: {
            name: "2 Way Radios",
            icon: con_spa_2_way_rad,
            text: (
                <ul>
                    <ListItem text="Radios should be fully charged for the beginning of each shift, and a back-up radio should also be provided" />
                    <ListItem text="Only one operator can talk at a time by holding down talk button, talk while button held, when finished release talk button" />
                    <ListItem text="Operators should identify who is talking, who they are talking to and, give clear and concise instructions. They should finish with the work “Over”" />
                    <ListItem text="Radios should be tested 2 times daily for battery and agreed channel" />
                    <ListItem text="Mobile Phones should not be used as a replacement for 2-way radios" />
                </ul>
            )
        },

        con_spa_com: {
            name: "Communication/ Induction",
            icon: con_spa_com,
            text: (
                <ul>
                    <ListItem text="All new employees/ contractors entering a site should undergo an induction." />
                    <Li>
                        <Typography variant="title">
                            {" "}
                            The induction should cover the following topics
                        </Typography>
                        <ol>
                            <ListItem text="Site rules and procedures" />
                            <ListItem text="Arrangements for safety and welfare" />
                            <ListItem text="Key responsible people" />
                            <ListItem text="Emergency plans/ proceduresEmergency plans/ procedures" />
                            <ListItem text="Requirements for PPE (as per tasks to be undertaken)" />
                        </ol>
                    </Li>
                    <ListItem text="The completion of this SSWP may be used as part of the induction" />
                    <ListItem text="If the site, works, or hazards present change, then operatives should be re-inducted." />
                </ul>
            )
        },
        con_spa_com_ind: {
            name: "Communication Control",
            icon: con_spa_com_ind,
            text: (
                <ul>
                    <ListItem text="Anyone inside a confined space must be in verbal contact with someone on the outside." />
                    <ListItem text="There must be frequent and regular communication to check for response and attention" />
                    <ListItem text="Radios, or other communication tools should be spark free." />
                </ul>
            )
        },
        con_spa_tri: {
            name: "Tripod",
            icon: con_spa_tri,
            text: (
                <ul>
                    <ListItem text="This is a standard piece of rescue equipment for people working in confined spaces. It enables a “Top Man” to raise the worker out of the confined space. It also enables the “Top Man” to assist the worker enter the confined space." />
                    <ListItem text="Users must be trained in the operation of the tripod." />
                    <ListItem text="The equipment must be thoroughly examined in accordance with the manufacturer’s requirements, not exceeding 6 months (GA1)." />
                    <ListItem text="The equipment must be visually inspected weekly (GA3)." />
                    <ListItem text="Check for worn or damaged, or corroded parts before each use. Ensure all parts, including nuts and bolts, are present and secure. Ensure legs are straight, free from cracks and dents. Ensure pulleys freely rotate. " />
                    <ListItem text="The tripod must be used with a fall arrest system. Check the fall arrest and harness system, and follow the required controls." />
                    <ListItem text="When suspending working lines, check for obstructions or sharp edges in the work path. Avoid working where the user may swing and hit an object or where lines may cross or tangle with that of another worker." />
                    <ListItem text="When suspending a worker during work activity, or for personnel riding applications, a secondary or back-up fall arrest system will be required. A tripod is for single user use only (Rescue planning must take account of manufacturer instructions)" />
                    <ListItem text="A rescue plan will be required, and this must be understood by all workers involved in the operation." />
                    <ListItem text="The tripod must be levelled on firm ground capable of supporting the required weight. The tripod is positioned such that the line will be directly over the intended work area. The worker must not be required to swing to access the work area." />
                    <Li>
                        <Typography variant="title">
                            Guidelines on erecting (follow manufacturer
                            instructions)
                        </Typography>
                        <ListItem text="Lay tripod on working surface" />
                        <ListItem text="Adjust legs to required working height" />
                        <ListItem text="Tilt tripod into an upright position" />
                        <ListItem text="Fully spread legs, ensuring legs are against the bearing surface on the head. The legs must have a locking mechanism, and ALL legs must be locked." />
                        <ListItem text="Position tripod in the centre of the opening. Ensure footing is secure and sufficient to support load. Adjust to make level by adjusting leg length." />
                        <ListItem text="Ensure leg chains are taut. Do NOT use without the leg chains in place. These can only be removed if they are interfering with a rescue and it is safe to remove them." />
                        <ListItem text="Ensure line is securely attached and locked to the tripod." />
                    </Li>
                </ul>
            )
        },
        con_spa_res_equ: {
            name: "Respiratory Protective Equipment",
            icon: con_spa_res_equ,
            text: (
                <ul>
                    <ListItem text="Normally, for high risk confined space, this will be breathing apparatus." />
                    <ListItem text="Escape breathing apparatus (self-rescue device) should never be used for normal working, only for escape purposes." />
                    <ListItem text="The equipment must be CE marked" />
                    <ListItem text="The wearer, their supervisor, and manager require training on the apparatus. The training should cover both the use of and the maintenance of the equipment. The training should be refreshed regularly." />
                    <ListItem text="The apparatus should be stored correctly to prevent damage." />
                    <ListItem text="“Charged” apparatus should be segregated from apparatus that is awaiting refill, inspection, repair or maintenance." />
                    <ListItem text="The equipment needs to be inspected before each use. This will involve a thorough examination of all parts looking particularly at the integrity of the straps, faceplates, filters and valves. Checking of the cylinder pressure will be necessary for self-contained breathing apparatus. Air quality and flowrate should be checked in case of compressed airline breathing apparatus." />
                    <ListItem text="Any defects discovered must be repaired before use, or tagged “Out of Use” and sent for repair." />
                </ul>
            )
        },
        con_spa_acc_egr: {
            name: "Access/ Egress",
            icon: con_spa_acc_egr,
            text: (
                <ul>
                    <ListItem text="There must be safe walking routes for workers to/ from/ and within the site" />
                    <ListItem text="There must be safe access using ladders" />
                    <ListItem text="Access to be kept clear from obstruction, materials, and equipment" />
                    <ListItem text="Access should be kept clean and tidy" />
                </ul>
            )
        },
        con_spa_per_to_wor: {
            name: "Permit To Work",
            icon: con_spa_per_to_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        con_spa_tag_on_off: {
            name: "Tagon/ Tagoff",
            icon: con_spa_tag_on_off,
            text: (
                <ul>
                    <ListItem text="Tags are a visible means of isolating a hazard. They can be used as part of a permit to work system." />
                    <ListItem text="They form part of a system to prevent the inadvertent/ premature enabling of an energy source after the source has been “locked-out”." />
                    <ListItem text="Tags should only be removed (Tag Off) by the person who placed them (Tag On). The tag should include details on the date it was placed, expected expiry, and the name of the person who placed it. They should also give a warning, not to remove them (unless you are an authorized person). They may also include checklists to be completed before beginning the task, or after completing a task." />
                    <ListItem text="They should be highly visible, durable, weather/environment resistant and have a clear signing/marking system that will not be effected by weather/environment." />
                    <Li>
                        <Typography variant="title">
                            For confined spaces; Tags can be used to identify
                        </Typography>
                        <ol>
                            <ListItem text="Asphyxiation hazards, telling people not to enter unless they have a permit" />
                            <ListItem text="Confined Space, telling people not to enter unless they have a permit" />
                            <ListItem text="I Am In, telling people who is in the confined space, and when you should be out." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            For exclusion/ electrical hazards; Tags can be used
                            to identify
                        </Typography>
                        <ol>
                            <ListItem text="Entry Prohibited/Do Not Enter, telling people not to enter unless they have a permit" />
                            <ListItem text="Out of Service/Do Not Operate, telling people not to use the tool/ equipment" />
                            <ListItem text="Locked Out, telling people not to turn on the service or interfere with any of the controls/switches" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        con_spa_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: con_spa_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
